<template>
  <div class="flex h-full">
    <div class="flex w-full items-center">
      <div
        v-for="(step, index) in availableSteps"
        :key="index"
        class="flex flex-1 items-center"
        :class="{
          'flex-grow-0': index === availableSteps.length - 1,
        }"
      >
        <!-- Step Circle -->
        <div
          class="w-6 h-6 text-xs rounded-full flex items-center justify-center relative shrink-0"
          :class="getCircleClass(index)"
        >
          <template v-if="getStepState(index) === 'completed'">
            <ion-icon
              name="checkmark-outline"
              class="text-gray-800 w-4 h-4"
            ></ion-icon>
          </template>
          <template v-else>
            {{ index + 1 }}
          </template>
        </div>

        <!-- Horizontal Connection Line -->
        <div
          v-if="index < availableSteps.length - 1"
          class="flex-1 relative h-0.5 min-w-[2rem]"
        >
          <div
            class="absolute left-0 right-0 h-0.5"
            :class="getLineClass(index, false)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PortalBillingProposalHorizontalTimeline",
  // No emits needed as this component doesn't emit any events
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    availableSteps: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getStepState(index) {
      if (index + 1 < this.currentStep) {
        return "completed"
      }
      if (index + 1 === this.currentStep) {
        return "active"
      }
      return "inactive"
    },

    getCircleClass(index) {
      return {
        "bg-gray-700 text-gray-400": this.getStepState(index) === "inactive",
        "bg-gray-800 border border-white text-white": this.getStepState(index) === "active",
        "bg-green-600": this.getStepState(index) === "completed",
      }
    },

    getLineClass(index, isVertical) {
      const currentState = this.getStepState(index)
      const nextState = this.getStepState(index + 1)

      // Gray line conditions
      if (
        (currentState === "active" && nextState === "inactive") ||
        (currentState === "inactive" && nextState === "inactive")
      ) {
        return "bg-gray-700"
      }

      // Gradient progress condition
      if (currentState === "completed" && nextState === "active") {
        return isVertical
          ? "bg-gradient-to-b from-green-600 to-gray-700"
          : "bg-gradient-to-r from-green-600 to-gray-700"
      }

      // Solid complete condition
      if (currentState === "completed" && nextState === "completed") {
        return "bg-green-600"
      }

      // Default fallback
      return "bg-gray-700"
    },
  },
}
</script>
